var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-profile-header',{attrs:{"profileName":_vm.profileName,"profileType":_vm.profileType,"options":true,"idLabel":_vm.idLabelDecode}}),_c('app-list-artists',{attrs:{"id_artist":_vm.id_artist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }